import { Action } from '../../common/actions/core/action';
import { ActionHandler } from '../../common/actions/core/action-handler';

import { OpenPackageChurnRetentionSuccessAction } from './package-churn-retention-success-dialog.action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ITimeoutService, IWindowService } from 'angular';

/* @ngInject */
export default class PackageChurnRetentionSuccessDialog implements ActionHandler {
  private dialogElement;
  private messageSuccess;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private $translate,
    private $sce
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#packet-churn-success-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  handle(action: Action) {
    if (action instanceof OpenPackageChurnRetentionSuccessAction) {
      if (action.messageSuccess.day && action.messageSuccess.month && action.messageSuccess.year) {
        this.$translate('dialog.packet.churn.retention.success.messageDetail', action.messageSuccess).then(value => {
          this.messageSuccess = this.$sce.trustAsHtml(value);
        });
      } else {
        this.$translate('dialog.packet.churn.retention.success.message', action.messageSuccess).then(value => {
          this.messageSuccess = this.$sce.trustAsHtml(value);
        });
      }
      this.openDialog();
    }
  }

  public onClose() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  private close() {
    this.dialogElement.close();
    this.$window.location.href = "/?buySuccess=1"
  }
}



// WEBPACK FOOTER //
// ./src/app/packet/package-churn-retention-success-dialog/package-churn-retention-success-dialog.controller.ts